module.exports = __webpack_public_path__ + "static/img/funplus-logo.0cd3908.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/funplus/imgs/funplus-logo.png
// module id = 1967
// module chunks = 0